import { RoleData } from "@/enums/user";
import type { GlobalNavSectionType } from "@/types/common/library";
import { SITES_PATH } from "./paths";

export const SITES_NAV_SECTION_KEY = "sites";

/**
 * The sidebar's Sites section: one entry to the org's hosted documents, only while the org
 * has at least one. Every member may read their org's sites (Galactus scopes them to the
 * org), so the entry rides on `RoleData.Support`, which is visible to every role.
 */
export function sitesNavSection(hasSites: boolean, segments: readonly string[], label: string): GlobalNavSectionType | null {
  if (!hasSites) return null;
  return {
    sectionKey: SITES_NAV_SECTION_KEY,
    position: "top",
    items: [
      {
        icon: "file-lines",
        label,
        href: SITES_PATH,
        isActive: segments[0] === "sites",
        dataType: RoleData.Support,
      },
    ],
  };
}

/**
 * `sections` with the Sites entry appended to the last top section (General in the standard
 * nav), so it sits with the other workspace links instead of in a separate, unlabeled group.
 * When there is no top section, the Sites section is inserted before the bottom links.
 */
export function withSitesNavSection(sections: GlobalNavSectionType[], sitesSection: GlobalNavSectionType | null): GlobalNavSectionType[] {
  if (!sitesSection) return sections;
  const lastTop = sections.findLastIndex((section) => section.position !== "bottom");
  if (lastTop !== -1) {
    return sections.map((section, index) =>
      index === lastTop ? { ...section, items: [...section.items, ...sitesSection.items] } : section
    );
  }
  const firstBottom = sections.findIndex((section) => section.position === "bottom");
  const index = firstBottom === -1 ? sections.length : firstBottom;
  return [...sections.slice(0, index), sitesSection, ...sections.slice(index)];
}
